import { render, staticRenderFns } from "./OriginButton.vue?vue&type=template&id=5455a233&scoped=true&"
import script from "./OriginButton.vue?vue&type=script&lang=js&"
export * from "./OriginButton.vue?vue&type=script&lang=js&"
import style0 from "./OriginButton.vue?vue&type=style&index=0&id=5455a233&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455a233",
  null
  
)

export default component.exports